import Splide from '@splidejs/splide';

export const carousel = () => {
    var elms = document.getElementsByClassName( 'splide' );
    console.log(elms.length)
    for ( var i = 0; i < elms.length; i++ ) {
        const imageCarousel = elms[ i ].classList.contains('image-carousel');
        if (imageCarousel) {
            new Splide( elms[ i ], {
                type   : 'loop',
                perPage    : 3,
                perMove: 3,
                updateOnMove: true,
                breakpoints: {
                    1024: {
                        perPage    : 1,
                        perMove: 1,
                        padding: '15%',
                    },
                    725: {
                        type   : 'loop',
                        padding: '20%',
                    },
                }
            },).mount();
        } else {
            var slides = document.getElementsByClassName( 'splide__slide' );
            if (slides.length > 1) {
                new Splide( elms[ i ], { type: 'loop' }).mount();
            } else {
                new Splide( elms[ i ], { destroy: true }).mount();
            }
        }
    }
}
